import { render, staticRenderFns } from "./navigation-sub-button.vue?vue&type=template&id=48e779d0&scoped=true"
import script from "./navigation-sub-button.vue?vue&type=script&lang=ts"
export * from "./navigation-sub-button.vue?vue&type=script&lang=ts"
import style0 from "./navigation-sub-button.vue?vue&type=style&index=0&id=48e779d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e779d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
